export const basicAuth = {
    username: "Rajneesh@example.com",
    password: "Test@12345",
  };
  
  
  
  // export const billpunchbasicauth={
  //   username: "abhijeet@bumppy",
  //   password: "password",
  
  // }

   export const billpunchbasicauth={
    username: "$2b$10$wH8KxJ7yQ8Zy9pKJz7rQ1eO0z5b8YvF1k9xQ2uM7cL1mN8pQwE3yK",
    password: "$2b$10$X7sK9pQwE3yK8Zy9pKJz7rQ1eO0z5b8YvF1k9xQ2uM7cL1mN8pQwE",
  
  }